import React from "react"
import Icon from "icons"
import {
  Container,
  Wrapper,
  Heading,
  Item,
  ProcessList,
  ProcessWrapper,
  ProcessItem,
  ProcessItemHeader,
  ProcessItemBody,
  ProcessItemContainer,
} from "./styles"

const EnhancedList = ({ element }) => {
  const { title, items, style } = element

  if (style === "faq") {
    return (
      <Container>
        <Wrapper>
          <Heading id={`mbg-${element.anchor}`}>{title || "Frequently Asked Questions"}</Heading>
          {items.map(({ heading, id, body }) => (
            <Item key={id} title={heading} content={body} isArticleFAQ />
          ))}
        </Wrapper>
      </Container>
    )
  }

  if (style === "process") {
    return (
      <Container>
        <ProcessList>
          <Heading id={`mbg-${element.anchor}`}>{title || "Quick List"}</Heading>
          <ProcessWrapper>
            {items.map(({ heading, id, body }) => (
              <ProcessItem key={id}>
                <ProcessItemContainer>
                  <Icon
                    fill="none"
                    id="check-icon-black"
                    style={{ minWidth: "19px", minHeight: "14px" }}
                    width="19"
                    height="14"
                  />
                  <ProcessItemHeader dangerouslySetInnerHTML={{ __html: heading }} />
                </ProcessItemContainer>
                <ProcessItemBody dangerouslySetInnerHTML={{ __html: body }} />
              </ProcessItem>
            ))}
          </ProcessWrapper>
        </ProcessList>
      </Container>
    )
  }
}

export default EnhancedList
